import React from "react";
import userIcon from "../../../assets/icon/userIcon.svg";
import { getStudentData } from "../../../helper/localStorage";
export default function Profile() {
  const userData = getStudentData().data.master[0];

  return (
    <div className="profile">
      <div className="profile-blk">
        <div className="profile-img-blk">
          <img src={userIcon} alt="" />
        </div>
        <div className="profile-content">
          <h3 className="profile-name">
            {userData.firstname} {userData.lastname}
          </h3>
          <span className="profile-email">{userData.email}</span>
          <p className="profile-id">Student ID: {userData.std_no}</p>
          <p className="profile-sch-code">School Code: {userData.sch_code}</p>
        </div>
      </div>
    </div>
  );
}
